import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSession } from '../utils/utils';

const InfoDashboard = () => {
	const navigate = useNavigate();

	const [looker, setLooker] = useState("https://lookerstudio.google.com/embed/u/0/reporting/871aa3a3-d493-4e0b-af0c-168076f6a8e3/page/p_bmw0og1kqd")

	async function getInfo() {
		let session = await getSession();

		if (session === null) {
			navigate("/");
			return;
		}
		
		let lookerFilter = new URL(looker);

		// Default structure
		let params = {
			ds347: {
				rol_acceso: "admin",
			}
		};

		switch (session.role) {
			case "Admin":
			default:
				params.ds347.rol_acceso = "admin";
				break;

			case "Empresa":
				params.ds347.rol_acceso = "empresa";
				params.ds347.nit_acceso = session.nit;
				break;

			case "Sucursal":
				params.ds347.rol_acceso = "sucursal";
				params.ds347.nit_acceso = session.nit;
				break;
		}

		lookerFilter.searchParams.set("params", JSON.stringify(params));
		// console.log(lookerFilter);
		setLooker(lookerFilter);
	}

	useEffect(function() {
		getInfo();
	}, []);

	return (
		<div className='w-auto ml-32 h-full mr-6'>
			<div className='flex flex-row w-full h-full mt-4 justify-between'>
				{/* <button onClick={() => setRefreshData(!refreshData)}>Recargar</button> */}
				<iframe 
					className="w-full h-auto rounded-xl" 
					src={ looker }
					title="Looker"
					allowFullScreen
				/>
			</div>
		</div>
	)
}

export default InfoDashboard